import { Nullable, Identifiable } from '../common';
// import { EntryListItemViewModel as EntryDataListItem } from 'chaika-types';
import type { EntryListItemViewModel as EntryDataListItem } from 'chaika-types';
import { EntryTypeFieldName } from 'chaika-enums';

export const enum AllergenStatus {
    deleted = 'deleted',
}

export interface FieldValueItem<T = any> extends Identifiable<string> {
    value: T;
}

export interface FieldValueItemData<T = any> extends FieldValueItem<T> {
    isDeleted?: true;
}

export type FieldValueData = Nullable<string | Date | Number | Object | FieldValueItemData[]>;
export type FieldValueParams = Nullable<string | Date | Number | Object | FieldValueItem[]>;

export interface EntryFieldData {
    name: string | EntryTypeFieldName;
    value: FieldValueData;
}

export interface EntryVersionsResponse {
    versions: EntryDataListItem[];
}

export interface UpdateEntryFieldForm {
    value: FieldValueParams;
}

export interface DrugParams {
    id: string;
    activeSubstance: string;
    tradeName: string;
    frequencyIfReception: string;
    directions: string;
    startDate: string;
    endDate: string;
}

export const enum XmlDataType {
    Integer = 'ftInteger',
    DateTime = 'ftDateTime',
    String = 'ftString',
    Boolean = 'ftBoolean',
    Memo = 'ftMemo',
    Float = 'ftFloat',
    Table = 'ttTable',
}

export interface LegacyData {
    label: string;
    tableName: string;
    viewAsTable?: boolean;
    values: LegacyValue[];
}

export interface LegacyValue {
    label: string;
    fieldName: string;
    type: XmlDataType;
    noResume?: string;
    displayFormat?: string;
    value: string | number | boolean;
}
